import React from 'react'

import { Barra } from './styles'

export const BarraSuperior: React.FC = ({ children }) => (
  <Barra>{children}</Barra>
)
